module.exports = __webpack_public_path__ + "fa-regular-400.82f60bd0b94a1ed68b1e.svg";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-regular-400.svg
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-regular-400.svg
// module chunks = styles